import { useEffect } from 'react';
import config, { FeatureToggleState } from 'shared/config';

export const useSystemConfig = (onGetConfig: () => void) => {
  useEffect(() => {
    if (config.featureToggles.configRequest === FeatureToggleState.ON) {
      onGetConfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
